"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllOpeningsLayerPath = void 0;
const core_1 = require("@mapmaker/core");
/**
 * Return the best match for a layer or a prioritized list of layers in an opening.
 * undefined if no layers match.
 */
/*
export function getBestMatchedLayer(opening, layerOrLayers) {
  const layers = Array.isArray(layerOrLayers) ? layerOrLayers : [layerOrLayers];
  const matchedLayerName = layers.find(
    layerName => !!opening.getIn(["layout", layerName])
  );
  if (matchedLayerName) {
    return opening.getIn(["layout", matchedLayerName]);
  } else {
    return undefined;
  }
}
*/
/**
 * Returns an array of all of a openings in a blueprint.
 */
/*
export function getOpenings(blueprint) {
  return blueprint
    .get("features")
    .filter(feature => feature.get("type") == "OPENING");
}
*/
/**
 * Returns an immutable array of all of a openings in a blueprint which have a node on the
 * provided layer/layers.  layerOrLayers can either be a single string layer, or a prioritized
 * list of layers to look for in each opening.
 */
/*
export function getOpeningsWithLayer(blueprint, layerOrLayers) {
  return getOpenings(blueprint).reduce((openings, opening) => {
    // If there is a matched layer, add the opening to the list.
    if (getBestMatchedLayer(opening, layerOrLayers)) {
      openings.push(opening);
    }
    return openings;
  }, []);
}
*/
/**
 * Returns an immutable array of all of a particular opening layer from a given blueprint.
 * layerOrLayers can either be a single string layer, or a prioritized list of layers to look
 * for in each opening.
 */
/*
export function getOpeningLayerNodes(blueprint, layerOrLayers) {
  const openings = getOpeningsWithLayer(blueprint, layerOrLayers);
  if (!openings) {
    return null;
  }
  return openings.map(opening => getBestMatchedLayer(opening, layerOrLayers));
}
*/
/**
 * Returns a compound path built from all the layers of a given node.
 */
/*
export function getAllOpeningsLayerPath(blueprint, layerOrLayers) {
  const nodes = getOpeningLayerNodes(blueprint, layerOrLayers);
  if (!nodes) {
    return null;
  }
  return nodes
    .map(node => (getNodePathsRecursive(node) || []).join(" "))
    .join(" ");
}
*/
/**
 * Returns the complete compund path for the opening of a single node.
 */
/*
export function getOpeningLayerPath(opening, layerOrLayers) {
  const nodePaths = getNodePathsRecursive(
    getBestMatchedLayer(opening, layerOrLayers)
  );
  if (!nodePaths) {
    return null;
  } else {
    return nodePaths.join(" ");
  }
}
*/
function getCompoundPathIncludingChildren(nodeData) {
    var _a;
    let compoundPath = "";
    if (nodeData.d) {
        compoundPath += nodeData.d;
    }
    if (((_a = nodeData.children) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        compoundPath += nodeData.children.reduce((childrenPath, child) => {
            return childrenPath + getCompoundPathIncludingChildren(child);
        }, compoundPath);
    }
    return compoundPath;
}
function getAllOpeningsLayerPath(design, layer, shrinkBorderPt) {
    const w = design.width;
    const h = design.height;
    const layers = (0, core_1.getFeaturesList)(design, "OPENING")
        .map((feature) => feature.layout[layer])
        .filter(layer => layer);
    if (layers.length === 0 && layer !== "background") {
        return null;
    }
    const s = shrinkBorderPt;
    const s2 = s * 2;
    const path = layers.reduce((path, layer) => {
        return path + getCompoundPathIncludingChildren(layer);
    }, [
        // Comment to keep this from going to one line on lint
        `M ${s} ${s}`,
        `L ${s} ${h - s2}`,
        `L ${w - s2} ${h - s2}`,
        `L ${w - s2} ${s}`,
        `L ${s} ${s} z`,
    ].join(""));
    return path;
}
exports.getAllOpeningsLayerPath = getAllOpeningsLayerPath;
//# sourceMappingURL=data:application/json;base64,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